import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './translations/translations';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translations.en
      }
    },
    lng: 'en', // язык по умолчанию
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 
